module.exports = __webpack_public_path__ + "static/media/Equip-Asia-logo.1a9f21b4.png";